import { alertDateConstants } from '../constants/alert-date.constants';

export const openModalAlertDate = (data = {}) => ({
  type: alertDateConstants.OPEN_MODAL,
  payload: data,
});

export const closeModalAlertDate = () => ({
  type: alertDateConstants.CLOSE_MODAL,
});
